import Game from './game';

document.addEventListener("DOMContentLoaded", () => {
  const canvas = document.getElementById('canvas');
  canvas.width = 500;
  canvas.height = 500;

  const defaultDifficulty = 10;
  const game = new Game(defaultDifficulty);
  game.setUpGame();
});



//////////////////
// WEBPACK FOOTER
// ./js/maze_generator.js
// module id = 2
// module chunks = 0